var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"px-1 py-0 mr-2",attrs:{"variant":"outline-danger","size":"sm","title":_vm.trans('design_mode'),"disabled":_vm.busy},on:{"click":_vm.onClickDesignMode}},[_c('i',{staticClass:"fa fa-fw fa-edit"})])}
var staticRenderFns = []

export { render, staticRenderFns }